const { __ } = wp.i18n;
export default [
  {
    label: __("Normal", "uipress-lite"),
    value: "normal",
  },
  {
    label: __("Multiply", "uipress-lite"),
    value: "multiply",
  },
  {
    label: __("Screen", "uipress-lite"),
    value: "screen",
  },
  {
    label: __("Overlay", "uipress-lite"),
    value: "overlay",
  },
  {
    label: __("Darken", "uipress-lite"),
    value: "darken",
  },
  {
    label: __("Lighten", "uipress-lite"),
    value: "lighten",
  },
  {
    label: __("Color dodge", "uipress-lite"),
    value: "color-dodge",
  },
  {
    label: __("Color burn", "uipress-lite"),
    value: "color-burn",
  },
  {
    label: __("Hard light", "uipress-lite"),
    value: "hard-light",
  },
  {
    label: __("Soft light", "uipress-lite"),
    value: "soft-light",
  },
  {
    label: __("Difference", "uipress-lite"),
    value: "difference",
  },
  {
    label: __("Exclusion", "uipress-lite"),
    value: "exclusion",
  },
  {
    label: __("Hue", "uipress-lite"),
    value: "hue",
  },
  {
    label: __("Saturation", "uipress-lite"),
    value: "saturation",
  },
  {
    label: __("Color", "uipress-lite"),
    value: "color",
  },
  {
    label: __("Luminosity", "uipress-lite"),
    value: "luminosity",
  },
  {
    label: __("Initial", "uipress-lite"),
    value: "initial",
  },
  {
    label: __("Inherit", "uipress-lite"),
    value: "Inherit",
  },
  {
    label: __("Unset", "uipress-lite"),
    value: "Unset",
  },
];
